import styled from '@emotion/styled'
import { calcRem } from '@news-mono/component-library'

export const StyledInlineTaboolaAMP = styled('div')(({ theme }) => ({
    marginBottom: calcRem(10),
}))
